import { getSVGRequiredPath } from './getSVGRequiredPath';

export const SVGTokens = [
  'aapl', 'amd', 'amzn', 'arkk', 'baba', 'coin', 'eem', 'fb', 'gld', 'gme', 'googl', 'msft', 'nvda', 'pdbc', 'pltr', 'qqq', 'slv', 'spy', 'tlt', 'tsla', 'twtr', 'urth', 'vnq', 'usd',
].reduce((acc, token) => {
  acc[`d${token}`] = getSVGRequiredPath(`tokens/${token}`);
  return acc;
}, {});
